<footer class="footer-area">
    <div class="container-fluid">
        <div class="row mx-4">
            <div class="col-lg-3 col-md-4 col-sm-12">
                <a routerLink="/"><img src="assets/img/logo.png" width="164" alt="Logo"></a>
            </div>
            <div class="col-lg-9 col-md-8 col-sm-12 workingHours">
                <div class="row mx-4">
                    <div class="col-md-5">
                        <span class="openingHoursTitle">Opening Hours</span>
                    </div>
                    <div class="col-md-7">
                        <p class="openingHours">"{{working_hours || ''}}"</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="pt-4">
            <div class="row mx-4" style="border-bottom: 1px solid #000;">
                <div class="col-lg-3 col-md-6">
                    <p style="color: #fff;">More than just pizza it’s a family legacy of authentic taste since 1971.</p>
                    <div class="socialMedia">
                        <h5 class="text-white">Follow Us</h5>
                        <ul class="social-list">
                            <li class="social-icon"><a href="https://www.facebook.com/profile.php?id=61579869386721" target="_blank"><i class="bx bxl-facebook"></i></a></li>
                            <li class="social-icon"><a href="https://www.instagram.com/fontana_pizza_restaurant" target="_blank"><i class="bx bxl-instagram"></i></a></li>
                            <!-- <li class="social-icon"><a href="https://www.linkedin.com/company/one-pice-digital-solutions/" target="_blank"><i class="bx bxl-linkedin"></i></a></li> -->
                            <li class="social-icon"><a href="https://www.tiktok.com/@fontana_pizza_restaurant" target="_blank"><i class="bx bxl-tiktok"></i></a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-6">
                    <h5 class="text-white text-center">Menu Pages</h5>
                    <div class="footer-list d-flex">
                        <ul>
                            <li><a class="text-white" routerLink="/mainMenu">Main Menu</a></li>
                            <li><a class="text-white" routerLink="/menu/maincategory/1/lunch">Lunch Menu</a></li>
                            <li><a class="text-white" routerLink="/menu/maincategory/2/catering">Catering Menu</a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-6">
                    <h5 class="text-white text-center">Related links</h5>
                    <div class="footer-list d-flex">
                        <ul>
                            <li><a class="text-white" routerLink="/terms-condition">Terms</a></li>
                            <li><a class="text-white" routerLink="/privacy-policy">Privacy Policy</a></li>
                            <li><a class="text-white" routerLink="/order-apps">Order Apps</a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="footer-side-list">
                        <ul>
                            <li><i class='bx bxs-phone'></i> <a href="tel:{{phone}}">{{phone}}</a></li>
                            <li><i class='bx bxs-envelope'></i> <a href="mailto:{{email}}">{{email}}</a></li>
                            <li><i class='bx bxs-map'></i> <a href="https://maps.app.goo.gl/L7fK6dFPXimu74j17" target="_blank">{{address}}</a></li>
                        </ul>
                    </div>
                </div>


                <!-- <div class="col-lg-4 col-md-4">
                    <div class="footer-side-list">
                        <ul>
                            <li><i class='bx bxs-phone'></i> <a href="tel:{{phone}}">{{phone}}</a></li>
                            <li><i class='bx bxs-envelope'></i> <a href="mailto:{{email}}">{{email}}</a></li>
                            <li><i class='bx bxs-map'></i> <a href="https://maps.app.goo.gl/6xRRnn1AUrBJtjvf7" target="_blank">{{address}}</a></li>
                        </ul>
                    </div>
                </div> -->

                <!-- <div class="col-lg-4 col-md-4">
                    <div class="footer-list2">
                        <div class="text-center mb-4">
                            <i style="color: #000;" class="bx bxs-stopwatch"></i>
                        </div>
                        <div class="m-auto">
                            <p>"{{working_hours || ''}}"</p>
                        </div>
                    </div>
                </div> -->

                <!-- <div class="col-lg-4 col-md-4">
                    <div class="footer-side-list">
                        <ul>
                            <li><i class='bx bxs-phone'></i> <a href="tel:{{phone}}">{{phone}}</a></li>
                            <li><i class='bx bxs-envelope'></i> <a href="mailto:{{email}}">{{email}}</a></li>
                            <li><i class='bx bxs-map'></i> <a href="https://maps.app.goo.gl/6xRRnn1AUrBJtjvf7" target="_blank">{{address}}</a></li>
                        </ul>
                    </div>
                </div> -->
            </div>
        </div>
    </div>

    <div class="footer-bottom">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="bottom-text d-block">
                        <p class="pb-0">© 2026 Fontana . All rights reserved</p>
                        <p class="pt-1">Website Designed & Developed By <a href="http://onepice.org/" target="_blank">ONE PICE DIGITAL SOLUTIONS</a></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>